module.exports = __webpack_public_path__ + "dist/assets/b9d91d67c058f22f145bc85fa1f4ecc2.png";